//
// WARNING this file is automatically generated by release-gem
//

export const APP_VERSION = "6.25.1";

export const APP_TIMESTAMP = "1793742547";

